export const ProductCardLayoutType = {
  Main: 0,
  New: 1,
  Old: 2,
  Small: 3,
  PostBooking: 4,
  VI: 5,
  VISmall: 6
};
//# sourceMappingURL=productCardLayout.js.map